const STATES = {
  READY: 'ready',
  PENDING: 'pending',
  ERROR: 'error',
};

export default STATES;
